module.exports = __webpack_public_path__ + "img/4.e915913e.jpg";